import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-050",
  "use": "icon-050-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-050\">\r\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 5.33398L6.00213 1.33398H13.3319C13.7009 1.33398 14 1.63752 14 1.99518V9H12.6667V2.66732H6.66667V6.00065H3.33333V13.334H9V14.6673H2.66227C2.29651 14.6673 2 14.3674 2 13.9961V5.33398ZM10.3096 12.3095L12.6666 14.6665L15.9664 11.3667L15.0236 10.4238L12.6666 12.7809L11.2524 11.3667L10.3096 12.3095Z\" fill=\"#6AA3FA\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol